import _ from 'lodash';
import SHARED_ROUTES from '../routes';

function buildBaseRoute({ isDemo, isKiosk, isEmbedded, isStoreFront, isMobileEcommApp, dispensary } = {}) {
  let href, route;

  if (isDemo) {
    href = SHARED_ROUTES.DEMO;
    route = SHARED_ROUTES.DEMO;
  } else if (isKiosk) {
    href = SHARED_ROUTES.KIOSKS;
    route = SHARED_ROUTES.KIOSKS;
  } else if (isEmbedded) {
    href = SHARED_ROUTES.EMBEDDED_MENU;
    route = SHARED_ROUTES.EMBEDDED_MENU;
  } else if (isMobileEcommApp) {
    href = SHARED_ROUTES.MOBILE_ECOMM;
    route = SHARED_ROUTES.MOBILE_ECOMM;
  } else if (isStoreFront) {
    href = SHARED_ROUTES.STORES;
    route = SHARED_ROUTES.STORES;
  } else if (dispensary) {
    href = SHARED_ROUTES.DISPENSARY;
    route = SHARED_ROUTES.DISPENSARY;
  } else {
    href = SHARED_ROUTES.SHOP;
    route = SHARED_ROUTES.SHOP;
  }

  return [href, route];
}

function addDispensaryRoutes({ href, route, dispensary, info } = {}) {
  if (dispensary && info) {
    href += `/${dispensary.cName}${SHARED_ROUTES.INFO}`;
    route += SHARED_ROUTES.CNAME_INFO;
  } else if (dispensary) {
    href += `/${dispensary.cName}`;
    route += SHARED_ROUTES.CNAME;
  }

  return [href, route];
}

function addProductRoutes({ href, route, product }) {
  href += `${SHARED_ROUTES.PRODUCT}${product.cName || product.id}`;
  route += SHARED_ROUTES.PRODUCT_ID;

  return [href, route];
}

function addSpecialsRoutes({ href, route, id, currentRoute, specialId }) {
  href += SHARED_ROUTES.SPECIALS;
  route += SHARED_ROUTES.SPECIALS;
  const generatedOfferSubroute = _.includes(id, 'offer');
  const generatedSaleSubroute = _.includes(id, 'sale');

  if (!generatedOfferSubroute && !generatedSaleSubroute && id) {
    href += `/${id || specialId}`;
    route += SHARED_ROUTES.OFFER_SPECIAL_ID;
  }
  if (generatedOfferSubroute) {
    href += `/${id || specialId}`;
    route += SHARED_ROUTES.OFFER_SPECIAL_ID;
  } else if (generatedSaleSubroute) {
    href += `/${id || specialId}`;
    route += SHARED_ROUTES.SALE_SPECIAL_ID;
  }
  if (!id) {
    if (_.includes(currentRoute, 'offer')) {
      href += `${SHARED_ROUTES.OFFER}/${specialId}`;
      route += SHARED_ROUTES.OFFER_SPECIAL_ID;
    } else if (_.includes(currentRoute, 'sale')) {
      href += `${SHARED_ROUTES.SALE}/${specialId}`;
      route += SHARED_ROUTES.SALE_SPECIAL_ID;
    }
  }

  return [href, route];
}

function buildExternalTemplateRoute({ routeRoot, brands, category, product, subcategory, specials }) {
  let href = routeRoot;

  if (brands) {
    href += `?dtche[path]=brands&dtche[brands]=${encodeURIComponent(brands)}`;
  } else if (specials) {
    href += `?dtche[path]=specials`;
  } else if (product) {
    href += `?dtche[product]=${encodeURIComponent(product.cName || product.id)}`;
  } else if (category && category.key) {
    href += `?dtche[category]=${encodeURIComponent(category.key)}`;
    if (subcategory) {
      href += `?dtche[subcategory]=${encodeURIComponent(subcategory)}`;
    }
  }
  return { href };
}

function buildStoreFrontRoute({ routeRoot, brands, category, product, subcategory, specials }) {
  let href = routeRoot;

  if (brands) {
    href += `${SHARED_ROUTES.BRANDS}?brands=${encodeURIComponent(brands)}`;
  } else if (specials) {
    href += SHARED_ROUTES.SPECIALS;
  } else if (product) {
    href += SHARED_ROUTES.PRODUCT + encodeURIComponent(product.cName || product.id);
  } else if (category && category.key) {
    href += SHARED_ROUTES.PRODUCTS + encodeURIComponent(category.key);
    if (subcategory) {
      href += `/${encodeURIComponent(subcategory)}`;
    }
  }
  return { href };
}

function isStoreFrontRouteRoot(routeRoot) {
  if (!routeRoot) {
    return false;
  }

  const splitRoute = _.split(routeRoot, '/');
  // Storefront routes  have one of two patterns:
  // domain/store/{cName} || domain/stores/{cName}
  return splitRoute.length > 1 && _.includes(['stores', 'store'], splitRoute[splitRoute.length - 2]);
}

function buildCheckoutRoute({ dispensary, isDemo, isStoreFront, isEmbedded, isMobileEcommApp }) {
  let href, route;

  if (isDemo) {
    href = SHARED_ROUTES.DEMO;
    route = SHARED_ROUTES.DEMO;
  } else if (isEmbedded && dispensary) {
    // embedded-menu has its own checkout route
    href = `${SHARED_ROUTES.EMBEDDED_MENU}/${dispensary.cName}`;
    route = SHARED_ROUTES.EMBEDDED_MENU_CNAME;
  } else if (isStoreFront && dispensary) {
    // storefront has its own checkout route
    href = `${SHARED_ROUTES.STORES}/${dispensary.cName}`;
    route = SHARED_ROUTES.STORES_CNAME;
  } else if (isMobileEcommApp && dispensary) {
    // mobile ecomm has its own checkout route
    href = `${SHARED_ROUTES.MOBILE_ECOMM}/${dispensary.cName}`;
    route = SHARED_ROUTES.MOBILE_ECOMM;
  } else {
    href = '';
    route = '';
  }

  href += SHARED_ROUTES.CHECKOUT;
  route += SHARED_ROUTES.CHECKOUT;

  return [href, route];
}

function buildHomeRoute() {
  return [`/`, `/`];
}

function buildDispensariesRoute() {
  return [SHARED_ROUTES.DISPENSARIES, SHARED_ROUTES.DISPENSARIES];
}

export {
  addDispensaryRoutes,
  addProductRoutes,
  addSpecialsRoutes,
  buildBaseRoute,
  buildCheckoutRoute,
  buildDispensariesRoute,
  buildExternalTemplateRoute,
  buildHomeRoute,
  buildStoreFrontRoute,
  isStoreFrontRouteRoot,
};
